export const AVAILABLE_WIDGETS_KEY = Symbol()

export const DASHBOARD_EXPORT_KEY = Symbol()

export const CUSTOM_VIEW_NAME = 'Custom'
